import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import {getCourseDurationString} from '../../../../../utils/entity/course';
import {isDefined} from '../../../../../utils/typecheck';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {actor, course, membership, program} = contexts;

  const courseDates = getCourseDurationString(course);
  const hasCourseStartDate = isDefined(course?.start_date);

  const wasMembershipRequested = !!membership?.sign;
  const wasMembershipDeclined = isDefined(membership?.decline?.reason);

  let courseI18nPath = 'default';
  let programI18nPath = 'default';

  switch (true) {
    case wasMembershipRequested:
      courseI18nPath = 'request_accepted';
      break;
    case wasMembershipDeclined:
      courseI18nPath = 'conditions_changed';
      programI18nPath = 'conditions_changed';
      break;
    default:
      break;
  }

  return {
    avatar: program?.avatar,
    avatarPlaceholder: program?.title,
    // @ts-expect-error: TODO: describe why
    buttons:
      membership?.status === 'proposed'
        ? [
            wasMembershipDeclined
              ? {
                  id: 'show_program_changes_button',
                  label: i18n.t('shared:show_changes'),
                  scheme: 'secondary',
                }
              : null,
            {
              id: 'invite_learn_more_button',
              label: i18n.t('shared:learn_more'),
              scheme: 'secondary',
            },
            {
              id: 'decline_invite_button',
              label: i18n.t('shared:decline'),
              scheme: 'danger',
            },
          ].filter(Boolean)
        : [],
    subAvatar: actor?.avatar,
    subAvatarPlaceholder: actor?.name,
    title:
      /**
       * @i18n_parser
       *
       * t('notifications:membership_proposed.title.course.default')
       * t('notifications:membership_proposed.title.course.request_accepted')
       * t('notifications:membership_proposed.title.course.conditions_changed')
       * t('notifications:membership_proposed.title.program.default')
       * t('notifications:membership_proposed.title.program.conditions_changed')
       */
      i18n.t(
        `notifications:membership_proposed.title.${
          hasCourseStartDate
            ? `course.${courseI18nPath}`
            : `program.${programI18nPath}`
        }`,
        {
          actorName: actor?.name,
          courseDates:
            hasCourseStartDate && courseDates ? `(${courseDates})` : '',
          programTitle: program?.title,
        },
      ),
  };
};
